<template>
  <svg width="17" height="16" viewBox="0 0 17 16" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.09125 10.25L0.75 12.875V1.25C0.75 1.05109 0.829018 0.860322 0.96967 0.71967C1.11032 0.579018 1.30109 0.5 1.5 0.5H12.75C12.9489 0.5 13.1397 0.579018 13.2803 0.71967C13.421 0.860322 13.5 1.05109 13.5 1.25V10.25H4.09125ZM3.57225 8.75H12V2H2.25V9.78875L3.57225 8.75ZM6 11.75H13.6777L15 12.7887V5H15.75C15.9489 5 16.1397 5.07902 16.2803 5.21967C16.421 5.36032 16.5 5.55109 16.5 5.75V15.875L13.1588 13.25H6.75C6.55109 13.25 6.36032 13.171 6.21967 13.0303C6.07902 12.8897 6 12.6989 6 12.5V11.75Z" fill="#040410" fill-opacity="0.6"/>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconFeedback'
})
export default class extends Vue {
  @Prop({ default: '#128c7e' }) color!: string
}
</script>

<style scoped>
</style>
